"use client";
import React from "react";
export default function TaxComparisonSection() {
  return (
    <section className="bg-black h-auto py-[60px] flex justify-center min-[1340px]:px-0 px-4">
      <div className="w-full max-w-[848px] flex flex-col gap-[50px] items-center">

        {/* TEXT */}
        <div className="w-full flex flex-col gap-6">
          <p className="text-white text-[16px] leading-[24px] font-medium">
            Founders usually begin researching this after realising how much tax
            they&apos;re paying locally.
          </p>

          {/* CARDS */}
          <div className="flex flex-col md:flex-row w-full rounded-[16px] overflow-hidden">
            
            {/* CARD 1 */}
            <div className="flex-1 border-2 border-white/10 p-6 flex flex-col gap-4 rounded-t-[16px] md:rounded-l-[16px] md:rounded-tr-none">

              <div className="uppercase text-white font-cambo">
                <span className="text-[24px] leading-[110%] font-normal">$100k </span>
                <span className="text-[14px] leading-[110%] font-normal">profit</span>
              </div>

              <div className="border-t-2 border-white/10 w-full"></div>

              <div className="flex flex-col gap-1 ">
                <span className="text-white/70 text-[14px] ">Typical country tax</span>
                <span className="text-[#ff6067] text-[16px] font-medium">$25,000–$30,000</span>
              </div>

              <div className="flex flex-col gap-1">
                <span className="text-white/70 text-[14px]">HK offshore tax</span>
                <span className="text-[#00a63e] text-[16px] font-medium">$0</span>
              </div>

              <div className="flex flex-col gap-1">
                <span className="text-white/70 text-[14px]">Potential savings</span>
                <span className="text-white text-[16px] font-medium">$25k–$30k</span>
              </div>
            </div>

            {/* CARD 2 */}
            <div className="flex-1 bg-[#0f1218] p-6 flex flex-col gap-4">

              <div className="uppercase text-white font-cambo">
                <span className="text-[24px] leading-[110%] font-normal">$250k </span>
                <span className="text-[14px] leading-[110%] font-normal">profit</span>
              </div>

              <div className="border-t-2 border-white/10 w-full"></div>

              <div className="flex flex-col gap-1">
                <span className="text-white/70 text-[14px]">Typical country tax</span>
                <span className="text-[#ff6067] text-[16px] font-medium">$25,000–$30,000</span>
              </div>

              <div className="flex flex-col gap-1">
                <span className="text-white/70 text-[14px]">HK offshore tax</span>
                <span className="text-[#00a63e] text-[16px] font-medium">$0</span>
              </div>

              <div className="flex flex-col gap-1">
                <span className="text-white/70 text-[14px]">Potential savings</span>
                <span className="text-white text-[16px] font-medium">$62k–$75k</span>
              </div>
            </div>

            {/* CARD 3 */}
            <div className="flex-1 border-2 border-white/10 p-6 flex flex-col gap-4 rounded-b-[16px] md:rounded-r-[16px] md:rounded-bl-none">

              <div className="uppercase text-white font-cambo">
                <span className="text-[24px] leading-[110%] font-normal">$500k </span>
                <span className="text-[14px] leading-[110%] font-normal">profit</span>
              </div>

              <div className="border-t-2 border-white/10 w-full"></div>

              <div className="flex flex-col gap-1">
                <span className="text-white/70 text-[14px]">Typical country tax</span>
                <span className="text-[#ff6067] text-[16px] font-medium">$125,000–$150,000</span>
              </div>

              <div className="flex flex-col gap-1">
                <span className="text-white/70 text-[14px]">HK offshore tax</span>
                <span className="text-[#00a63e] text-[16px] font-medium">$0</span>
              </div>

              <div className="flex flex-col gap-1">
                <span className="text-white/70 text-[14px]">Potential savings</span>
                <span className="text-white text-[16px] font-medium">$125k–$150k</span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}